const initStory = (section) => {
  if (!section || section.dataset.sealYogStoryReady === 'true') return;
  section.dataset.sealYogStoryReady = 'true';

  section.querySelectorAll('[data-yog-story-compare]').forEach((compare) => {
    const range = compare.querySelector('[data-yog-story-compare-range]');
    if (!range) return;

    const update = () => {
      compare.style.setProperty('--seal-yog-compare-position', `${range.value}%`);
    };

    range.addEventListener('input', update);
    update();
  });

  section.addEventListener('click', (event) => {
    const purchaseLink = event.target.closest('[data-seal-yog-it-purchase]');
    if (!purchaseLink) return;

    const productTarget = document.querySelector(
      '#MainContent .product-information, #product-information.product-information, [id^="ProductInformation-"]',
    );
    if (!productTarget) return;

    event.preventDefault();
    productTarget.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  });
};

const initAllStories = () => {
  document.querySelectorAll('[data-seal-yog-it-story]').forEach(initStory);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllStories);
} else {
  initAllStories();
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target?.querySelector?.('[data-seal-yog-it-story]');
  if (section) {
    section.dataset.sealYogStoryReady = 'false';
    initStory(section);
  }
});
